import { PushSendTest } from '@/features/push-credentials';
import type { PushProviderFormProps, PushProviderFormState } from '../types';
import { PushConfigBody } from './push-config-body';
import { PushSaveBar } from './push-save-bar';

export type PushProviderPanelProps = PushProviderFormProps & {
  form: PushProviderFormState;
};

export function PushProviderPanel({
  workspaceId,
  platform,
  platforms,
  isEditing,
  canEdit,
  canDelete,
  showDisable,
  chooser,
  onEditingChange,
  form,
}: PushProviderPanelProps) {
  // Testable once the form would produce a working credential, or once one is
  // stored — a test then goes through the stored key instead.
  const canTest = form.isComplete || form.isEnabled;
  // An edit of a stored credential has nothing to send until something changes;
  // a first setup does, so its Save is open from the start.
  const isUnchanged = form.isEnabled && !form.isDirty;

  return (
    <PushConfigBody
      errors={form.errors.errors}
      onDismissError={form.errors.dismissError}
      isBusy={form.isBusy}
      chooser={chooser}
      fields={form.fields}
      saveBar={
        <PushSaveBar
          platform={platform}
          isEditing={isEditing}
          isSaving={form.isSaving}
          isUnchanged={isUnchanged}
          isBusy={form.isBusy}
          canEdit={canEdit}
          canDelete={canDelete}
          showDisable={showDisable}
          onSave={form.save}
          onCancel={form.cancel}
          onStartEditing={() => onEditingChange(true)}
          onDisable={form.disable}
        />
      }
      sendTest={
        canTest ? (
          <PushSendTest
            workspaceId={workspaceId}
            platform={platform}
            provider={form.provider}
            sandbox={form.sandbox}
            configuredPlatformCount={platforms.length}
            getCredentials={form.getCredentials}
            isDisabled={false}
            onErrors={(apiErrors) => form.errors.addErrors('sendTest', apiErrors)}
          />
        ) : null
      }
    />
  );
}
